<template>
  <v-card elevation="0">
    <v-card-title>공지사항</v-card-title>
    <v-card-text>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>
            ★ 5월 2일 데브몬 10주년 창립기념일 축하 ★
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>[공지] 데브몬 인트라넷 오픈</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>[공지] INID-K 사용자 오픈</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title></v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title></v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-card-text>
  </v-card>
</template>

<script>
export default {};
</script>

<style></style>
